import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Employee} from "../../../../../interfaces/Employee";
import {EmployeeService} from "../../../../../services/employee.service";
import {CounsellingSessionReviewService} from "../counselling-session-review.service";
import firebase from "firebase/compat/app";
import {Cancel} from "axios";
import {ActivatedRoute, Router} from "@angular/router";
import {LogService} from "../../../../../services/log.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

export interface CounsellorEvaluation {
  id?: string;                     // Auto when fetching from Firestore
  sessionDate: Date | string;      // Session date
  counsellor: string;              // Dropdown - team names
  observedBy: string;              // Dropdown - Krisha / Vaishali
  counsellingSkills: number;       // Rating 1–5
  interventions: number;           // Rating 1–5
  understandingOfProblem: number;  // Rating 1–5
  homeProgram: number;             // Rating 1–5
  feedback?: string;               // Optional text field
  createdAt?: any;                 // Firestore timestamp
  updatedAt?: any;                 // Firestore timestamp
}

export enum SkillRating {
  LACKS = 1,
  NEEDS_IMPROVEMENT = 2,
  SATISFACTORY = 3,
  GOOD = 4,
  EXCELLENT = 5
}


@Component({
  selector: 'app-counselling-session-review',
  templateUrl: './counselling-session-review.component.html',
  styleUrls: ['./counselling-session-review.component.scss']
})
export class CounsellingSessionReviewComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  counsellorReviewForm !: FormGroup;
  // counselorName: any
  // employeeData!: Employee[];
  selectedCounselorName: string[] = []
  observers = ['Krisha', 'Vaishali'];
  currentEditId:any;
  ratings = [
    {value: '1-LACKS', label: '1-LACKS'},
    {value: '2-NEEDS IMPROVEMENT', label: '2-NEEDS IMPROVEMENT'},
    {value: '3-SATISFACTORY', label: '3-SATISFACTORY'},
    {value: '4-GOOD', label: '4-GOOD'},
    {value: '5-EXCELLENT', label: '5-EXCELLENT'},
    {value: '6-NA', label: '6-NA'}
  ];
  isLoading: boolean = false;

  counselorName: any[] = [];
  employeeData: any[] = [];
  maxDate: Date;


  constructor(private fb: FormBuilder,
              private reviewService : CounsellingSessionReviewService,
              private mEmployeeService: EmployeeService,
              private router: Router,
              private route : ActivatedRoute,
              private userService: EmployeeService,
              private mLogService: LogService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              protected mDialogRef:MatDialogRef<CounsellingSessionReviewComponent>,) {
    this.maxDate = new Date();
  }

  ngOnInit(): void {
    this.formInit();
    // this.fetchUsers();



    this.fetchCounsellor();


    this.currentEditId = this.data?.id || null;

    if (this.data) {
      this.currentEditId = this.data.id;
      this.counsellorReviewForm.patchValue({
        sessionDate: this.data.sessionDate?.toDate?.() || this.data.sessionDate,
        counsellor: this.data.counsellor,
        observedBy: this.data.observedBy,
        counsellingSkills: this.data.counsellingSkills,
        interventions: this.data.interventions,
        understandingOfProblem: this.data.understandingOfProblem,
        homeProgram: this.data.homeProgram,
        feedback: this.data.feedback
      });
    }

  }


  fetchCounsellor() {
    this.mEmployeeService.getUsers().pipe(takeUntil(this._destroyed$)).subscribe(snapshotchanges => {
      this.employeeData = snapshotchanges.map(w => {
        let emp = w.payload.toJSON() as any;
        if (w.key != null) {
          emp['id'] = w.key;
        }
        return emp;
      });

      const namesToRemove = ['Shilpa Pahuja', 'Mukti Panchamia'];

      this.counselorName = this.employeeData
        .filter(emp => (emp.role === 'Counsellor' || emp.role === 'Sr Counsellor') && emp.disabled !== true)
        .map(emp => ({ name: emp.userName }))     // IMPORTANT → component requires { name: ... }
        .filter(c => !namesToRemove.includes(c.name))
        .sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  onCounselorSelected(selected: any) {
    this.resetForm();
    this.counsellorReviewForm.get('counsellor')?.setValue(selected.name);
  }


  formInit() {
    this.counsellorReviewForm = this.fb.group({
      sessionDate: ['', Validators.required],
      counsellor: ['', Validators.required],
      observedBy: ['', Validators.required],
      counsellingSkills: [null, Validators.required],
      interventions: [null, Validators.required],
      understandingOfProblem: [null, Validators.required],
      homeProgram: [null],
      feedback: ['']
    });
  }
  submitForm() {
    if (this.counsellorReviewForm.invalid) return;

    this.isLoading = true;
    const formData: CounsellorEvaluation = {
      ...this.counsellorReviewForm.value,
      sessionDate: new Date(this.counsellorReviewForm.value.sessionDate),
    };

    if (this.currentEditId) {
      // 🔹 Update existing review
      this.reviewService.update(this.currentEditId, {
        ...formData,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      })
        .then(() => {
          const activity = {
            date: new Date().getTime(),
            section: 'Counselling',
            action: 'Updated',
            description: `Counsellor review updated by user`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);

          alert('Updated successfully!');
          // this.router.navigate(['/home/counseling/counselling-session-reviews-list']);
          this.mDialogRef.close(true);
          this.resetForm();
        })
        .catch(error => {
          console.error('Error updating review:', error);
          alert('Error updating review!');
        })
        .finally(() => {
          this.isLoading = false;
        });

    } else {
      // 🔹 Create new review
      this.reviewService.create({
        ...formData,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      })
        .then(() => {
          const activity = {
            date: new Date().getTime(),
            section: 'Counselling',
            action: 'Created',
            description: `New counsellor review created by user`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);

          alert('Saved successfully!');
          // this.router.navigate(['/home/counseling/counselling-session-reviews-list']);
          this.mDialogRef.close(true);
          this.resetForm();
        })
        .catch(error => {
          console.error('Error creating review:', error);
          alert('Error creating review!');
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  fetchUsers() {
    this.userService.getUsers().pipe(takeUntil(this._destroyed$)).subscribe(snapshotchanges => {
      this.employeeData = snapshotchanges.map(w => {
        let emp = w.payload.toJSON() as Employee;
        if (w.key != null) {
          emp['id'] = w.key;
        }
        return emp;
      });

      const namesToRemove = ['Shilpa Pahuja', 'Mukti Panchamia'];

      this.counselorName = this.employeeData
        .filter(employee => (employee?.role === 'Counsellor' || employee?.role === 'Lead Counsellor' || employee?.role === 'Sr Counsellor')&& employee.disabled !== true)
        .map(counsellingEmployee => ({ name: counsellingEmployee?.userName })) // wrap as object
        .filter(c => !namesToRemove.includes(c?.name))
        .sort((a, b) => a?.name.localeCompare(b?.name));
    });

  }

  resetForm() {
    this.counsellorReviewForm.reset();
    this.currentEditId = null;
  }

  // onCancel() {
  //   this.router.navigate(['/home/counseling/counselling-session-reviews-list']);
  // }

  onCancel() {
    this.mDialogRef.close();
  }

  get remarkLength(): number {
    const val: string = this.counsellorReviewForm.get('feedback')?.value || '';
    return val.length;
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
